module.exports = __webpack_public_path__ + "static/media/sunday.d42c2626.png";